<template>
  <div>
    <TeamStatusControl :subject="slide.settings.subject" type="votes"></TeamStatusControl>
  </div>
</template>

<script>
import BaseSlide from './BaseSlide';
import TeamStatusControl from "../controls/TeamStatusControl";

export default {
	name: 'VoteSlide',
	mixins: [BaseSlide],
  components: {
	  TeamStatusControl
  },
};
</script>

<style></style>
